import GroupMemberRecord from "models/view-models/group-member-record";
import ServiceHookFactory from "../service-hook-factory";

// ---------------------------------------------------------------------------------------------
// #region Interfaces
// ---------------------------------------------------------------------------------------------

export interface GroupMemberBasePathParams {
    groupId: number;
}

export interface GroupMemberListQueryParams {}

// #endregion Interfaces

// ---------------------------------------------------------------------------------------------
// #region Constants
// ---------------------------------------------------------------------------------------------

const baseEndpoint = "groups/:groupId/members";
const resourceType = GroupMemberRecord;

// #endregion Constants

const GroupMemberService = {
    /**
     * Retrieves a list of GroupMember resources based upon supplied group Id
     */
    useList: ServiceHookFactory.useNestedList<
        GroupMemberRecord,
        GroupMemberBasePathParams,
        GroupMemberListQueryParams
    >(resourceType, baseEndpoint),
};

export default GroupMemberService;
